import { render, staticRenderFns } from "./ChatContextView.vue?vue&type=template&id=2135fc24&scoped=true"
import script from "./ChatContextView.vue?vue&type=script&lang=js"
export * from "./ChatContextView.vue?vue&type=script&lang=js"
import style0 from "./ChatContextView.vue?vue&type=style&index=0&id=2135fc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135fc24",
  null
  
)

export default component.exports